const 工作地点 = [
  '北京',
  '上海',
  '广州',
  '深圳',
  '香港',
  '成都',
  '杭州',
  '重庆',
  '武汉',
  '苏州',
  '西安',
  '天津',
  '南京',
  '郑州',
  '长沙',
  '沈阳',
  '青岛',
  '宁波',
  '东莞',
  '无锡',
  '昆明',
  '大连',
  '厦门',
  '合肥',
  '佛山',
  '福州',
  '哈尔滨',
  '济南',
  '温州',
  '长春',
  '石家庄',
]
const 部门角色 = ['A角', 'B角', '团队长']
const 专业职级表头 = ['ManagingPartner', 'Partner', 'MD', 'ED', 'D', 'AD', 'SVP', 'VP', 'SA', 'Asso', 'AN']
const 管理职级表头 = [
  '专员',
  '主管',
  '经理',
  '副总监',
  '总监',
  '部门总助',
  '部门副总',
  '一级部门总',
  '二级部门总',
  '公司总助',
  '公司副总',
  '公司总经理',
]
const 香港牌照 = [
  '证券交易',
  '期货合约交易',
  '杠杆式外汇交易',
  '就证券提供意见',
  '就期货合约提供意见',
  '就机构融资提供意见',
  '提供自动化交易服务',
  '提供证券保证金融资',
  '提供资产管理',
  '提供信贷评级服务',
]
const 香港牌照对应 = {
  证券交易: '一',
  期货合约交易: '二',
  杠杆式外汇交易: '三',
  就证券提供意见: '四',
  就期货合约提供意见: '五',
  就机构融资提供意见: '六',
  提供自动化交易服务: '七',
  提供证券保证金融资: '八',
  提供资产管理: '九',
  提供信贷评级服务: '十',
}
const 公司性质 = [
  '外商独资',
  '中外合资',
  '民营企业',
  '国有企业',
  '国内上市企业',
  '政府机关',
  '非营利机构',
  '事业单位',
  '其他',
]
const 投资阶段 = ['种子期', '初创期', '成长期', '成熟期']
const 公司附件类型 = [
  '阿尔法认知',
  '职能模块认知',
  '公司简介',
  '薪酬/职级/奖金机制',
  '公司O-Chart',
  '客户会面',
  '特殊要求',
  '推荐模板',
  '开票信息',
  '竞标文件',
  '应聘登记表',
  '合同',
  '其他',
]
const 项目人选标签 = [
  {
    label: '领导力',
    key: 'leadership',
    children: ['领导力强', '领导力弱', '逆商高', '逆商低', '强资源和人脉'],
  },
  {
    label: '个人风格',
    key: 'personal',
    children: [
      '保守',
      '稳健',
      '开拓（追求卓越）',
      '激进（狼性文化）',
      'social型',
      '学术研究型',
      '适合美元',
      '适合人民币',
      '具有创业精神',
      '情商高',
      '校友资源型',
      '政府资源型',
      '远见型','命令型','民主型','赞赏型','变革型','服务型',
    ],
  },
  {
    label: '专业因素',
    key: 'professional',
    children: [
      '专业能力强',
      '销售能力强',
      '研究功底扎实',
      '逻辑思维强',
      '思维散乱',
      '沟通能力强',
      '表达能力弱',
      '商业意识强',
      '执行力强',
    ],
  },
  {
    label: '心态、个性',
    key: 'mentality',
    children: [
      '心态积极正向',
      '消极负面',
      '战略思维、注重长远',
      '看重短期',
      '事业心强',
      '追求家庭工作平衡',
      '追求创新',
      '个性求稳',
      '积极进取',
      '结果导向',
    ],
  },
]
const 公司用人偏好 = {
  平台: ['A', 'B', 'C'],
  业绩: ['a', 'b', 'c', 'd'],
  学历: [
    '博士及以上',
    '硕士',
    '本科',
    '常青藤',
    '清北交复',
    '985',
    '211',
    '常春藤',
    '海外背景',
    'QS100',
    'TIMES100',
    '理工科',
    '财务',
    '法务',
    '金融',
    '医药医疗',
    '微电子',
    '计算机',
    '中金line',
    '中信line',
    '建投line',
    '广发学历',
    '前海开源line',
  ],
  语言能力: ['英文-1-母语水平', '英文-2-工作语言', '英文-3-可顺利读写，口语较弱', '粤语', '日语', '法语', '小语种'],
  职业资格: [
    '保代',
    '准保',
    '保代A类',
    '保代B类',
    '保代C类',
    '基金从业资格',
    '证券从业资格',
    'CFA',
    'CPA',
    'FRM',
    '律师执业资格',
    '法律从业资格',
    'REITs基金经理从业资格',
    '期货从业资格',
    '银行从业资格',
    'CIA（审计师）',
    'ACCA（国际注册会计师）',
    'CMA（美国注册管理会计师）',
    'CISA（信息系统审计师）',
    'CTA（税务师）',
    'SOA（北美保险精算师）',
    'CAA（保险精算师）'
  ],
}
const 公司用人偏好标签 = [
  // {
  //   label: '平台',
  //   key: '平台',
  //   children: ['A', 'B', 'C'],
  // },
  // {
  //   label: '业绩',
  //   key: '业绩',
  //   children: ['a', 'b', 'c', 'd'],
  // },
  // {
  //   label: '学历',
  //   key: '学历',
  //   children: [
  //     '博士及以上',
  //     '硕士',
  //     '本科',
  //     '常青藤',
  //     '清北交复',
  //     '985/211',
  //     '常春藤',
  //     '海外背景',
  //     'QS100',
  //     'TIMES100',
  //   ],
  // },
  // {
  //   label: '语言能力',
  //   key: '语言能力',
  //   children: ['英文-1-母语水平', '英文-2-工作语言', '英文-3-可顺利读写，口语较弱', '粤语', '日语', '法语', '小语种'],
  // },
]
const 新建公司标签 = [
  { label: '一句话简介', key: '一句话简介', type: 'string', accesorytype: '' },
  { label: '面试地址', key: '面试地址', type: 'array', accesorytype: '' },
  { label: '对接hr', key: '对接hr', type: 'array', accesorytype: '' },
  { label: '特殊要求', key: '特殊要求', type: 'string', accesorytype: '' },
  { label: '面试安排', key: '面试安排', type: 'string', accesorytype: '' },
  {
    label: '用人偏好',
    key: ['用人偏好', 'tags'],
    type: 'group',
    accesorytype: '公司用人偏好',
  },
  {
    label: '公司介绍',
    key: '公司介绍',
    type: 'string',
    accesorytype: '',
  },
  {
    label: '领导介绍',
    key: '领导介绍',
    type: 'string',
    accesorytype: '',
  },
  {
    label: '户口政策',
    key: '户口政策',
    type: 'string',
    accesorytype: '',
  },
  {
    label: '奖金递延及补偿机制',
    key: '奖金递延及补偿机制',
    type: 'string',
    accesorytype: '',
  },
  {
    label: '休假制度',
    key: '休假制度',
    type: 'string',
    accesorytype: '',
  },
  {
    label: '公司亮点',
    key: '公司亮点',
    type: 'object',
    accesorytype: 'SellingPoint',
  },
  {
    label: '公司劣势',
    key: '公司劣势',
    type: 'object',
    accesorytype: '公司优劣势',
  },
  {
    label: '业务特点/风格/资源来源',
    key: '业务特点/风格/资源来源',
    type: 'object',
    accesorytype: '业务特点/风格/资源来源',
  },
  {
    label: '薪酬/职级/奖金机制',
    key: ['薪酬/职级/奖金机制', 'hasSet', '部门薪酬'],
    type: 'group',
    accesorytype: '薪酬/职级/奖金机制',
  },
  {
    label: '附件上传',
    key: 'accesory',
    type: 'upload',
    option: 公司附件类型,
    accesorytype: '其他',
  },
]
const 公司标签 = [
  {
    label: '基本信息',
    key: [
      {
        key: '公司类型',
        placeholder: '公司类型',
        type: 'select',
        option: ['重点客户', '客户公司', '目标客户', '暂不合作'],
      },
      {
        key: '签约',
        placeholder: '签约',
        type: 'select',
        option: ['已签约', '项目拟客户', '跟进中'],
      },
      { key: '客户开发', placeholder: '客户开发', type: 'select' },
      {
        key: '别名',
        placeholder: '别名',
        type: 'tags',
      },
      { key: '网址', placeholder: '网址', type: 'input' },
      { key: '总部所在地', placeholder: '总部所在地', type: 'input' },
      {
        key: '办公地',
        placeholder: '办公地',
        type: 'selectinput',
        option: 工作地点,
      },
      { key: '行业', placeholder: '行业', type: 'select', option: app.industries || [] },
      {
        key: '香港牌照',
        placeholder: '香港牌照',
        type: 'selectmul',
        option: 香港牌照,
      },
      {
        key: '公司性质',
        placeholder: '公司性质',
        type: 'select',
        option: 公司性质,
      },
      {
        key: '股东方',
        placeholder: '股东方',
        type: 'input',
      },
      {
        key: '平台等级',
        placeholder: '平台等级',
        type: 'select',
        option: ['A', 'B', 'C'],
      },
    ],
    type: 'group',
    accesorytype: '',
  },
  { label: '一句话简介', key: '一句话简介', type: 'string', accesorytype: '' },
  {
    label: '户口政策',
    key: '户口政策',
    type: 'string',
    accesorytype: '',
  },
  {
    label: '奖金递延及补偿机制',
    key: '奖金递延及补偿机制',
    type: 'string',
    accesorytype: '',
  },
  {
    label: '休假制度',
    key: '休假制度',
    type: 'string',
    accesorytype: '',
  },
  { label: '面试地址', key: '面试地址', type: 'array', accesorytype: '' },
  { label: '对接hr', key: '对接hr', type: 'array', accesorytype: '' },
  {
    label: '用人偏好',
    key: ['用人偏好', 'tags'],
    type: 'group',
    accesorytype: '公司用人偏好',
  },
  {
    label: '公司介绍',
    key: '公司介绍',
    type: 'string',
    accesorytype: '公司简介',
  },
  {
    label: '领导介绍',
    key: '领导介绍',
    type: 'string',
    accesorytype: '',
  },
  {
    label: '公司亮点',
    key: '公司亮点',
    type: 'object',
    accesorytype: 'SellingPoint',
  },
  {
    label: '公司劣势',
    key: '公司劣势',
    type: 'object',
    accesorytype: '公司优劣势',
  },
  {
    label: '业务特点/风格/资源来源',
    key: '业务特点/风格/资源来源',
    type: 'object',
    accesorytype: '业务特点/风格/资源来源',
  },
  {
    label: '薪酬/职级/奖金机制',
    key: ['薪酬/职级/奖金机制', 'categoryMoneyTable'],
    type: 'group',
    accesorytype: '薪酬/职级/奖金机制',
  },
  {
    label: '特殊要求',
    key: '特殊要求',
    type: 'string',
    accesorytype: '特殊要求',
  },
  {
    label: '面试安排',
    key: '面试安排',
    type: 'string',
    accesorytype: '',
  },
  { label: 'list管理', key: 'list', type: 'accesory', accesorytype: 'list' },
  {
    label: '公司ochart',
    key: 'companySuperList',
    type: 'button',
    accesorytype: '公司O-Chart',
  },
  {
    label: '附件',
    key: 'accesory',
    type: 'upload',
    option: 公司附件类型,
    accesorytype: '全部',
  },
]
const 附件对应 = {
  公司简介: '公司介绍',
  '薪酬/职级/奖金机制': '薪酬/职级/奖金机制',
  SellingPoint: '公司亮点',
  '公司O-Chart': '公司ochart',
  公司优劣势: '公司劣势',
  公司用人偏好: '用人偏好',
  '业务特点/风格/资源来源': '业务特点/风格/资源来源',
  特殊要求: '特殊要求',
  推荐模板: '其他',
  list: 'list管理',
  其他: '其他',
}
const 基本信息字段 = [
  {
    key: '排名',
    placeholder: '排名',
    type: 'input',
  },
  {
    key: '公司类型',
    placeholder: '公司类型',
    type: 'select',
    option: ['重点客户', '客户公司', '目标客户', '暂不合作'],
  },
  {
    key: '签约',
    placeholder: '签约',
    type: 'select',
    option: ['已签约', '项目拟客户', '跟进中'],
  },
  { key: '客户开发', placeholder: '客户开发', type: 'select' },
  { key: '网址', placeholder: '网址', type: 'input' },
  { key: '总部所在地', placeholder: '总部所在地', type: 'input' },
  {
    key: '公司性质',
    placeholder: '公司性质',
    type: 'select',
    option: 公司性质,
  },
  {
    key: '股东方',
    placeholder: '股东方',
    type: 'input',
  },
  {
    key: '平台等级',
    placeholder: '平台等级',
    type: 'select',
    option: ['A', 'B', 'C'],
  },
]
const fieldsInSplitComponent = [
  '业务特点/风格/资源来源',
  '公司亮点',
  '公司劣势',
  '一句话简介',
  '公司介绍',
  '面试安排',
  '户口政策',
  '休假制度',
  '奖金递延及补偿机制',
  '薪酬/职级/奖金机制',
  '简称',
  '公司类型',
  '签约时间',
  '平台',
  '行业',
  '排名',
  '公司性质',
  '客户评级',
  '股东方',
  '总部所在地',
  '办公地',
  '网址',
  '别名',
  '客户开发',
  '签约',
]
const 面试问题 = [
  '你为什么想做猎头？（人选对职业规划的思考，尤其看逻辑）',
  '你了解猎头行业吗？你觉得猎头的工作是什么？',
  '到目前为止，你遇到过最大的挫折是？是怎么解决的？',
  '你人生中让你最有成就感的事是什么？',
  '你在选择一份工作时会考量哪些因素？是怎样排列的？为什么这样排列？（老板同事、公司平台、钱、职业发展路径等）',
  '你觉得自己最突出的优缺点是什么？',
  '你为这次面试准备了什么？',
  '有什么从小坚持到现在的习惯/爱好/癖好么？',
  '面试官自由发挥-其他问题',
]
const 省份坐标 = {
  山东: { x: '117.024967066', y: '36.6827847272' },
  河北: { x: '114.522081844', y: '38.0489583146' },
  吉林: { x: '125.313642427', y: '43.8983376071' },
  黑龙江: { x: '126.657716855', y: '45.7732246332' },
  辽宁: { x: '123.432790922', y: '41.8086447835' },
  内蒙古: { x: '111.66035052', y: '40.8283188731' },
  新疆: { x: '87.5649877411', y: '43.8403803472' },
  甘肃: { x: '103.823305441', y: '36.064225525' },
  宁夏: { x: '106.206478608', y: '38.5026210119' },
  山西: { x: '112.550863589', y: '37.890277054' },
  陕西: { x: '108.953098279', y: '34.2777998978' },
  河南: { x: '113.64964385', y: '34.7566100641' },
  安徽: { x: '117.282699092', y: '31.8669422607' },
  江苏: { x: '118.778074408', y: '32.0572355018' },
  浙江: { x: '120.219375416', y: '30.2592444615' },
  福建: { x: '119.330221107', y: '26.0471254966' },
  广东: { x: '113.307649675', y: '23.1200491021' },
  江西: { x: '115.893527546', y: '28.6895780001' },
  海南: { x: '110.330801848', y: '20.022071277' },
  广西: { x: '108.297233556', y: '22.8064929356' },
  贵州: { x: '106.709177096', y: '26.6299067414' },
  湖南: { x: '112.979352788', y: '28.2134782309' },
  湖北: { x: '114.316200103', y: '30.5810841269' },
  四川: { x: '104.067923463', y: '30.6799428454' },
  云南: { x: '102.714601139', y: '25.0491531005' },
  西藏: { x: '91.111890896', y: '29.6625570621' },
  青海: { x: '101.76792099', y: '36.640738612' },
  天津: { x: '117.210813092', y: '39.1439299033' },
  上海: { x: '121.487899486', y: '31.24916171' },
  重庆: { x: '106.530635013', y: '29.5446061089' },
  北京: { x: '116.395645038', y: '39.9299857781' },
  台湾: { x: '114.130474436', y: '22.3748329286' },
  香港: { x: '114.172902', y: '22.285828' },
  澳门: { x: '113.54469', y: '22.200924' },
}
const 职级2描述 = {
  '1': '高管',
  '2': '部门总',
  '3': '部门副总/总助/团队长',
  '4': '部门核心骨干',
  '5': '新人三年以下',
}

const 专业职级排序 = {
  ManagingPartner: 1,
  Partner: 2,
  MD: 3,
  ED: 4,
  D: 5,
  AD: 6,
  SVP: 7,
  VP: 8,
  SA: 9,
  Asso: 10,
  AN: 11,
}

const 芯片子行业 = [
  '智能硬件',
  '汽车电子',
  '安防监控',
  '工业控制',
  '军工航天',
  '能源控制',
  '消费电子',
  '通信网络',
  '移动手持',
  '医疗电子',
]
const 子行业 = {
  医药: ['医药服务'],
  医疗器械: [
    '医疗设备',
    '医用耗材',
    '手术器械',
    '医学实验仪器',
    '家用医疗器械',
    '介入类医疗器械',
    '植入材料和人工器官',
    '体外诊断产品',
    '医疗器械销售',
    '医疗设备租赁',
    '医疗设备检查和维修',
  ],
  医疗健康: ['医疗技术', '医疗信息化'],
  医疗人工智能: ['智能医疗设备', '智能医疗技术', '智能医疗服务'],
  芯片设计: 芯片子行业,
  芯片制造: 芯片子行业,
  EDA: 芯片子行业,
  封装测试: 芯片子行业,
  半导体材料: 芯片子行业,
}
const 行业产品 = {
  医疗设备: [
    '诊断设备',
    '治疗设备',
    '手术设备',
    '护理设备',
    '制药设备',
    '医用消毒灭菌设备',
    '植入设备',
    '康复设备',
    '医美设备',
    '基因测序设备研发',
    'POCT即时检测',
    '医用X射线设备',
    '医用激光仪器设备',
    '医用电子仪器设备',
    '医用超声仪器设备',
    '医用磁共振设备',
    '医用高分子材料及制品',
    '医用放射治疗设备',
    '医疗电子设备',
    '智能医疗设备',
    '医用核素设备',
    '医用高频仪器设备',
    '临床检验分析仪器',
    '体外循环及血液处理设备',
    '医用光学器具、仪器及内窥镜设备',
  ],
  医用耗材: [
    '一次性医疗耗材',
    '医用消毒液',
    '医用石膏',
    '卫生辅料耗材',
    '牙科耗材',
    '手术缝合耗材',
    '注射穿刺耗材',
    '医用导管',
    '测序耗材试剂研发',
  ],
  介入类医疗器械: ['心血管介入器械'],
  植入材料和人工器官: ['关节置换植入物', '骨科植入物', '心血管植入物', '脊柱植入物', '软组织重建及置换植入物'],
  体外诊断产品: ['体外诊断仪器', '体外诊断试剂', '试剂盒'],
  医药服务: [
    '药物研发',
    '药品生产',
    '医药中间体',
    '医药销售',
    '医药零售',
    '医药电商',
    '医药外包',
    '生物制药',
    '化学制药',
    '中药',
    '医药安全',
    '医药检测',
    '生物医药',
  ],
  医疗技术: [
    '生物技术',
    '精准医疗',
    '基因检测',
    '基因治疗',
    '医疗3D打印',
    '辅助生殖',
    '免疫治疗',
    '细胞技术',
    '微无创',
  ],
  医疗信息化: [
    '慢病管理',
    '远程医疗',
    '移动医疗',
    '医保信息化',
    '医疗搜索',
    '智慧医疗',
    '分级诊疗',
    '医疗信息系统',
    '互联网医疗',
    '区块链医疗',
    '医疗智能硬件',
    '智能医疗终端',
    '其他医疗信息化',
    '医疗SaaS',
    '数字疗法',
    '医药大数据',
  ],
  智能医疗设备: ['外骨骼机器人', '医疗机器人', '康复机器人'],
  智能医疗技术: ['医疗大数据', '人工智能医疗影像', '语音交互', '虚拟助手'],
  智能医疗服务: ['健康管理'],
}
export {
  工作地点,
  专业职级表头,
  管理职级表头,
  公司性质,
  投资阶段,
  公司附件类型,
  公司用人偏好,
  项目人选标签,
  公司标签,
  基本信息字段,
  新建公司标签,
  附件对应,
  部门角色,
  香港牌照,
  香港牌照对应,
  公司用人偏好标签,
  fieldsInSplitComponent,
  面试问题,
  省份坐标,
  职级2描述,
  专业职级排序,
  子行业,
  行业产品,
}
